import React, { useState } from 'react';
import { APP_VERSION, IOS_APP_STORE_URL, ANDROID_APK_URL } from '../config';
import AppStoreBadge from '../components/AppStoreBadge';
import AndroidBadge from '../components/AndroidBadge';
import '../App.css';
import { HiSpeakerphone } from 'react-icons/hi';
import { screenshots } from '../constants/screenshots';

function Home() {
    const [modalImage, setModalImage] = useState(null);

    const handleIOSDownload = () => {
        window.open(IOS_APP_STORE_URL, '_blank');
    };

    const handleAndroidDownload = () => {
        window.location.href = ANDROID_APK_URL;
    };

    const openModal = (imageSrc) => {
        setModalImage(imageSrc);
    };

    const closeModal = () => {
        setModalImage(null);
    };

    return (
        <div className="container">
            {/* Logo and App Name */}
            <header>
                <div className="top-header">
                    <img src="/logos/myGUNITransparent.png" alt="Logo" className="header-logo" />
                    <h1 className="app-name">myGUNI</h1>
                    <div className="header-version">v{APP_VERSION}</div>
                </div>
            </header>

            {/* Main Content = App Description + Download Buttons */}

            <section className="main-content">
                <div className="content-center">
                    <div className="app-description">
                        <p>
                            <span className="highlight">myGUNI</span> is your <span className="highlight">all-in-one app</span> for students. Enjoy <span className="highlight">tutorial switching helper</span>, <span className="highlight">announcements</span>, full <span className="highlight">portal access</span>, <span className="highlight">CMS integration</span>, and <span className="highlight">mail support</span>—all in one secure app with a <span className="highlight">clean, modern design</span>.
                        </p>
                    </div>

                    <div className="download-section">
                        <AppStoreBadge onClick={handleIOSDownload} />
                        <AndroidBadge onClick={handleAndroidDownload} />
                    </div>

                    <a href="/announcements" className="view-announcements-btn">
                        <HiSpeakerphone size={24} />
                        View Announcements
                    </a>
                </div>
            </section>

            {/* Screenshots */}
            <section className="screenshots-section">
                <h2 className="section-title">Screenshots</h2>
                <div className="screenshots-container">
                    {screenshots.map((screenshot) => (
                        <img
                            key={screenshot.id}
                            src={screenshot.src}
                            alt={screenshot.alt}
                            className="screenshot"
                            onClick={() => openModal(screenshot.src)}
                        />
                    ))}
                </div>
            </section>

            {/* Disclaimer Section */}
            <section className="disclaimer-wrapper">
                <div className="disclaimer-section">
                    <p className="disclaimer-text">
                        <strong>Disclaimer:</strong> This app is not affiliated with or endorsed by the German University in Cairo (GUC) or the German International University (GIU) in any
                        way. It is an independent student-created project designed to make accessing GUC & GIU related information easier. All
                        trademarks and copyrights remain the property of their respective owners.
                    </p>

                    <div className="privacy-section">
                        <h3>🔒 Privacy First</h3>
                        <p>Your username and password are never stored on our servers. All authentication is done directly with the GUC & GIU portals.</p>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="footer">
                <div className="footer-links">
                    <a href="/" className="footer-link">Home</a>
                    <a href="/announcements" className="footer-link">Announcements</a>
                    <a href="/privacy-policy.html" className="footer-link">Privacy Policy</a>
                    <a href="/faq.html" className="footer-link">FAQ</a>
                </div>
                <p>&copy; 2026 myGUNI. All rights reserved.</p>
            </footer>

            {/* Modal */}
            {modalImage && (
                <div className="modal" onClick={closeModal}>
                    <img src={modalImage} alt="Screenshot" className="modal-image" />
                </div>
            )}


        </div>
    );
}

export default Home;
